module.exports = __webpack_public_path__ + "static/media/kids_male_actors_temp.26d26f21.jpg";